/**
 * 农历转换工具（基于1900-2100年农历数据）
 * 参考：shubing_pc/frontend/src/utils/lunar.ts、https://github.com/zzyss86/LunarCalendar
 */

const lunarInfo = [
  0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2,
  0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977,
  0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970,
  0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557,
  0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573, 0x052b0, 0x0a9a8, 0x0e950, 0x06aa0,
  0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0,
  0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0, 0x195a6,
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570,
  0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0,
  0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5,
  0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530,
  0x05aa0, 0x076a3, 0x096d0, 0x04bd7, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45,
  0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0,
  0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4, 0x0aae0,
  0x0a2e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0, 0x055d4,
  0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0, 0x052b0,
  0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4, 0x0d160,
  0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a2d0, 0x0d150, 0x0f252,
  0x0d520,
]

const lunarMonths = ['正', '二', '三', '四', '五', '六', '七', '八', '九', '十', '冬', '腊']
const lunarDays = [
  '初一', '初二', '初三', '初四', '初五', '初六', '初七', '初八', '初九', '初十',
  '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十',
  '廿一', '廿二', '廿三', '廿四', '廿五', '廿六', '廿七', '廿八', '廿九', '三十',
]

function getDaysBetween1900(year, month, day) {
  const baseUTC = Date.UTC(1900, 0, 31)
  const targetUTC = Date.UTC(year, month - 1, day)
  return Math.floor((targetUTC - baseUTC) / (1000 * 60 * 60 * 24))
}

function getLeapMonth(year) {
  const yearIndex = year - 1900
  if (yearIndex < 0 || yearIndex >= lunarInfo.length) return 0
  return lunarInfo[yearIndex] & 0xf
}

function getLunarYearDays(year) {
  const yearIndex = year - 1900
  if (yearIndex < 0 || yearIndex >= lunarInfo.length) return 0
  const v = lunarInfo[yearIndex]
  let total = 0
  for (let i = 0x8000; i > 0x8; i >>= 1) {
    total += (v & i) ? 30 : 29
  }
  const leap = v & 0xf
  if (leap > 0) total += (v & 0x10000) ? 30 : 29
  return total
}

function getLunarMonthDays(year, month) {
  const yearIndex = year - 1900
  if (yearIndex < 0 || yearIndex >= lunarInfo.length) return 29
  return (lunarInfo[yearIndex] & (0x10000 >> month)) ? 30 : 29
}

function getLeapMonthDays(year) {
  const leap = getLeapMonth(year)
  if (leap === 0) return 0
  const yearIndex = year - 1900
  return (lunarInfo[yearIndex] & 0x10000) ? 30 : 29
}

function solarToLunar(year, month, day) {
  let offset = getDaysBetween1900(year, month, day)
  if (offset < 0) return null
  let temp = 0
  let lunarYear = 1900
  while (lunarYear < 2101 && offset > 0) {
    temp = getLunarYearDays(lunarYear)
    offset -= temp
    lunarYear++
  }
  if (offset < 0) {
    offset += temp
    lunarYear--
  }
  const leapMonth = getLeapMonth(lunarYear)
  let isLeap = false
  let lunarMonth = 1
  let monthDays = 0
  while (lunarMonth <= 12 && offset > 0) {
    if (leapMonth > 0 && lunarMonth === leapMonth + 1 && !isLeap) {
      lunarMonth--
      isLeap = true
      monthDays = getLeapMonthDays(lunarYear)
    } else {
      monthDays = getLunarMonthDays(lunarYear, lunarMonth)
    }
    if (isLeap && lunarMonth === leapMonth + 1) isLeap = false
    offset -= monthDays
    if (!isLeap) lunarMonth++
  }
  if (offset === 0 && leapMonth > 0 && lunarMonth === leapMonth + 1) {
    if (isLeap) isLeap = false
    else { isLeap = true; lunarMonth-- }
  }
  if (offset < 0) {
    offset += monthDays
    lunarMonth--
  }
  const lunarDay = offset + 1
  if (lunarMonth < 1 || lunarMonth > 12 || lunarDay < 1 || lunarDay > 30) return null
  return { year: lunarYear, month: lunarMonth, day: lunarDay, isLeap }
}

/**
 * 获取农历日期字符串
 * @param {Date} date 本地时区日期
 * @returns {string} 如 "正月十五"
 */
export function getLunarDate(date) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  if (year < 1900 || year > 2100) return ''
  try {
    if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function') {
      const formatter = new Intl.DateTimeFormat('zh-CN-u-ca-chinese', { month: 'long', day: 'numeric' })
      const parts = formatter.formatToParts(new Date(year, month - 1, day))
      const monthPart = parts.find(p => p.type === 'month')?.value
      const dayPart = parts.find(p => p.type === 'day')?.value
      if (monthPart && dayPart) {
        const dayNum = parseInt(dayPart, 10)
        const dayName = Number.isNaN(dayNum) ? dayPart : (lunarDays[dayNum - 1] || dayPart)
        return `${monthPart}${dayName}`
      }
    }
    const lunar = solarToLunar(year, month, day)
    if (!lunar) return ''
    if (lunar.isLeap) return `闰${lunarMonths[lunar.month - 1]}月${lunarDays[lunar.day - 1]}`
    return `${lunarMonths[lunar.month - 1]}月${lunarDays[lunar.day - 1]}`
  } catch (e) {
    return ''
  }
}
